module.exports = __webpack_public_path__ + "img/ISMSP_logo.ed98311.png";